import React, { useCallback, useState } from "react";

/**
 * SEARCH-006: Global Search UI (Shell)
 * 
 * Hook for managing the global search palette state.
 * 
 * Features:
 * - Keyboard shortcuts handled via useGlobalHotkeys
 * - Accessible from every screen
 * - No modal anxiety or visual noise
 */

export function useGlobalSearchPalette() {
  const [open, setOpen] = useState(false);
  
  const openPalette = useCallback(() => setOpen(true), []);
  const closePalette = useCallback(() => setOpen(false), []);
  const togglePalette = useCallback(() => setOpen(prev => !prev), []);
  
  return {
    open,
    setOpen,
    openPalette,
    closePalette,
    togglePalette,
  };
}
